import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {RoomUser} from "@/core/api/room.user.api"
import {roomRecordService} from "@/core/service/room.record.service";
import {gooroomeeMediaExtension} from "@/lib/gooroomee/webrtc/GooroomeeMediaExtension";
import _ from 'lodash'
import { RoomInfo } from '@/core/api/room.info.api'

class RoomRecordApi extends BaseApi {
    userDevice = {}
    recordStatus
    #roomRecord

    constructor() {
        super();
        Room.Record = this;

        Room.ready(async () => {
            if(!RoomInfo.useModule('record')){
                return;
            }

            this._eventListen(this.#Events);

            this.#roomRecord = await this.getRecordFileList();
            Room.emit({
                type: 'room_record_init',
                data: _.cloneDeep(this.#roomRecord),
            })
            
            let info = Room.getRoomData()
            gooroomeeMediaExtension
                .removeEventListener('record-state-change')
                .addEventListener('record-state-change', (e)=>{
                    Room.emit('room_record_changeClientRecordState', e.data);

                    this.recordStatus = e.data.state;

                    if (this.recordStatus === 'recording') {
                        try {
                            gooroomeeMediaExtension.Record.muteAudioInput(info.me.micStatus !== 'on');
                        } catch (e) {
                          console.error('GooroomeeMediaExtension.Record.muteAudioInput[start] :', e, e.stack);
                        }
                    }
                })
                .removeEventListener('req-record-start-with-server')
                .addEventListener('req-record-start-with-server', ()=>{
                    if(RoomUser.hasEmceeRole()){
                        this.changeRoomRecordState('start');
                    }else{
                        Room.emit('room_record_recordError', {reason: '권한부족'});
                    }
                })
                .removeEventListener('record-server-send-remain-start')
                .addEventListener('record-server-send-remain-start', (e)=>{
                    Room.emit('room_record_recordServerSendRemainStart', e.data);
                })
                .removeEventListener('record-server-send-remain-progress')
                .addEventListener('record-server-send-remain-progress', (e)=>{
                    Room.emit('room_record_recordServerSendRemainProgress', e.data);
                })
                .removeEventListener('record-error')
                .addEventListener('record-error', (e)=>{
                    console.error(e);
                    Room.emit('room_record_recordError', e.data);
                })
                .removeEventListener('webrtc-req-rec-audio-session')
                .addEventListener('webrtc-req-rec-audio-session', ()=>{
                    // room.sendMessage('/room/call/requestRecvAudioOnlySession');
                })
                .removeEventListener('webrtc-leave-rec-audio-session')
                .addEventListener('webrtc-leave-rec-audio-session', ()=>{
                    // room.sendMessage('/room/call/leaveRecvAudioOnlySession');
                })
                .removeEventListener('webrtc-send-answer')
                .addEventListener('webrtc-send-answer', ()=>{
                    // var data = e.data;
                    //
                    // Object.assign(data, {
                    //     toUserId: room.info.mixer.userId,
                    //     record: true
                    // });
                    //
                    // room.sendMessage('/room/call/answer', data);
                })
                .removeEventListener('webrtc-send-icecandidate')
                .addEventListener('webrtc-send-icecandidate', ()=>{
                    // room.sendMessage('/room/call/iceCandidate', {
                    //     toUserId: room.info.mixer.userId,
                    //     iceCandidate: event.data.icecandidate,
                    //     record: true
                    // });
                })
                .removeEventListener('webrtc-send-signalstable')
                .addEventListener('webrtc-send-signalstable', ()=>{
                    // room.sendMessage('/room/call/signalStable', {
                    //     toUserId: room.info.mixer.userId,
                    //     record: true
                    // });
                })
                .removeEventListener('webrtc-connection-failed')
                .addEventListener('webrtc-connection-failed', ()=>{
                    // THIS.sendMessage(
                    //     '/room/call/iceCandidateFailed',
                    //     {
                    //         reason: 'mixer_rejoin_sendfail',
                    //         record: true
                    //     }
                    // );
                });
            
            let extensionAppId = process.env.VUE_APP_CHROME_EXTENSION_APP_ID;
            if (extensionAppId) {
                gooroomeeMediaExtension.setChromeExtensionId(extensionAppId);
            }
            
            this.setExtensionEnable();
            Room.addEventListener('after_room_changeUserRoleId', async e => {
                const {userId} = e.data;
                if(RoomUser.isMe(userId)){
                    this.setExtensionEnable();
                }
            });
        });
    }
    
    isRecording(){
      return this.recordStatus === 'recording' 
        || this.recordStatus === 'paused'
    }

    setUserDevices(devicesSettings) {
        Object.assign(this.userDevice, devicesSettings);
    }
    
    setExtensionEnable() {
        let enable = RoomUser.hasEmceeRole();
        if(!enable && this.isRecording()){
            this.changeRoomRecordState('stop');
            Room.emit('room_record_forceToStop', {reason: '권한 부족'})
        }
        gooroomeeMediaExtension.Record.setEnable(enable);
    }

    async sendRecord() {
        if(this.__rec_start_job){
            console.log('record start already');
            return;
        }
        const job = this.__rec_start_job = this._sendRecord()
          .finally(() => {
              delete this.__rec_start_job;
          });
        setTimeout(() => {
            if(job === this.__rec_start_job){
                delete this.__rec_start_job;
            }
        }, 2000);
        return job;
    }

    async _sendRecord() {
        let info = Room.getRoomData();
        await roomRecordService.roomRecordClient().then((res) => {
            let data = res.data;
            if (data.code !== 'RT_SUCCESS') {
                throw 'server-error';
            }

            let server = data.data;
            let serverUrl = server.data.serverUrl;
            if(serverUrl.startsWith('http')){
                serverUrl = 'ws' + serverUrl.substring(4);
                server.data.serverWsUrl = serverUrl + '/ws/record';
            }

            let iceServers = [];
            let recordOptions = {
                recordServer: server.data,
                timeSliceMs: 1000,
                sendChunksTermMs: 1,
                sendChunksLimit: 51200,
                audioInput: (function () {
                    let status = info.me.micStatus;
                    if (status === 'none') {
                        return false;
                    }
                    return {
                        //deviceId: (THIS.userDevice && THIS.userDevice.selected && THIS.userDevice.selected.audioId),
                        deviceId: '',
                        mute: status !== 'on'
                    };
                }()),
                useExternalAudioTrack: false,
                iceServers: iceServers,
                videoBitsPerSecond: 1024*1024 * 1.5,
                maxWidth: window.screen.width,
                maxHeight: window.screen.height,
                maxFrameRate: 20,
            }

            return gooroomeeMediaExtension.Record.start(recordOptions);
        });
    }

    changeRoomRecordState(recordState) {
        if (recordState === 'start') {
            if (gooroomeeMediaExtension.getGooroomeeMeetingAppBrowser()) {
                return this.sendRecord();
            } else {
                return this.checkInstallChromeExtension()
                    .catch(e => {
                        throw e;
                    })
                    .then(() => {
                        return gooroomeeMediaExtension.Record.checkRecordPermission;
                    })
                    .then(() => {
                        return this.sendRecord();
                    })
            }
        } else {
            return gooroomeeMediaExtension.Record[recordState]();
        }
    }

    checkInstallChromeExtension() {
        return gooroomeeMediaExtension.installChromeExtension();
    }

    changeUserDeviceStatusWhileRecord(e) {
        if (this.recordStatus !== 'recording') {
            return;
        }

        const userId = e.data.userId;
        const deviceStatus = e.data.deviceStatus;
        const deviceType = e.data.deviceType;

        if (!Room.User.isMe(userId)) {
            return;
        }

        if (deviceType !== 'mic') {
            return;
        }

        gooroomeeMediaExtension.Record.muteAudioInput(deviceStatus !== 'on');
    }

    async getRecordFileList() {
        let {data = []} = await roomRecordService.getRoomRecordFileList();
        return data;
    }

    async getRecordFileUrl(recordId){
        let {data} = await roomRecordService.getRoomRecordFileUrl(recordId);
        if(!data || data.length < 1)
            throw 'file-not-existed';
        return data;
    }
    
    async deleteRecordFile(recordId){
        return await roomRecordService.deleteRecordFile(recordId);
    }

    #Events = {
        room_changeUserDeviceStatus: function (e) {
            this.changeUserDeviceStatusWhileRecord(e);
        },
        room_user_recordFileSaved: function (e) {
            let obj = this.#roomRecord.find(el => el.recordId === e.data?.record?.recordId);
            if(!obj)
                this.#roomRecord.unshift(_.cloneDeep(e.data?.record));
             
            Room.emit(e);
        },
    };
}

export const roomRecordApi = new RoomRecordApi();